import {gql} from '@apollo/client';

const GET_COUNTRY_COST_ENTRY = gql`
  query countryCostEntry($countryId: ID!, $year: Int!) {
    countryCostEntry(countryId: $countryId, year: $year) {
      year
      busCostEntry {
        adblueCost
        cleaningCost
        currency
        dieselCost
        flixStandardCost
        legalCost
        lngCost
        otherCost
        overheadCost
        repairCostPerDistanceUnit
        repairCostPerMonth
        tiresCost
        year
      }
      busTypeCostEntries {
        id
        busTypeId
        year
        customIdentifier
        insuranceCost
        interestCost
        leasingCost
        maintenanceCostPerMonth
        maintenanceCostPerDistanceUnit
        motorVehicleTax
        vehicleProductionYear
      }
      driverCostEntry {
        accommodationCostPerNight
        currency
        dailyAllowance
        daytimeWeekdaysWorkingHourCost
        daytimeWeekendsWorkingHourCost
        nighttimeWeekdaysWorkingHourCost
        nighttimeWeekendsWorkingHourCost
        prefilledEmptyDistance
        prefilledEmptyHr
        replacementCostPerHr
        replacementCostPerKm
        year
      }

      qualityChecked
    }
  }
`;

export default GET_COUNTRY_COST_ENTRY;
